var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-0",attrs:{"id":"Status"}},[_c('v-chip',{attrs:{"large":"","color":_vm.getColor(_vm.status),"text-color":"white"}},[_vm._v(" "+_vm._s(_vm.status)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }